<template>
  <v-container>
    <h1>SMART FORMS</h1>

    <v-card v-if="renderTable">
      <v-card-title>
        SMART FORMS
        <!-- <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field> -->
        <v-spacer></v-spacer>
      </v-card-title>
      <v-toolbar flat>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class="mb-2" @click="dialog = true">
          Add Form
        </v-btn>
      </v-toolbar>
      <v-data-table
        item-class="form-row"
        :headers="headers"
        :items="forms"
        :search="search"
        show-select
      >
        <!-- @click:row="openForm" -->
        <template v-slot:[`item.name`]="{ item }">
          <v-btn text @click="openForm(item)"
            ><h4>{{ item.name }}</h4></v-btn
          >
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small class="mr-2" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
          <v-icon small @click="openForm(item)">
            mdi-file-eye
          </v-icon>
        </template>
        <!-- <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">
            Reset
          </v-btn>
        </template> -->
      </v-data-table>

      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="pb-1 pt-5">
                  <v-text-field
                    dense
                    v-model="editedItem.name"
                    label="Form Name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-1">
                  <v-text-field
                    dense
                    v-model="editedItem.link"
                    label="Form Link"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-1">
                  <v-combobox
                    dense
                    v-model="editedItem.tags"
                    :items="tags"
                    :search-input.sync="tagSearch"
                    ref="formTags"
                    :menu-props="{
                      closeOnContentClick: true,
                      closeOnClick: true,
                    }"
                    hide-selected
                    hint="Form Tags"
                    label="Add some tags"
                    multiple
                    persistent-hint
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            No results matching "<strong>{{ tagSearch }}</strong
                            >". Press <kbd>enter</kbd> to create a new Tag
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template
                      v-slot:selection="{ attrs, item, parent, selected }"
                    >
                      <v-chip
                        v-bind="attrs"
                        :input-value="selected"
                        label
                        class="pr-2"
                        small
                      >
                        <span class="pr-2">
                          {{ item }}
                        </span>
                        <v-icon small @click="parent.selectItem(item)">
                          $delete
                        </v-icon>
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">
              Cancel
            </v-btn>
            <v-btn color="blue darken-1" text @click="save">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5"
            >Are you sure you want to delete this item?
          </v-card-title>
          <v-card-text> {{ editedItem.name }} Form </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete"
              >Cancel</v-btn
            >
            <v-btn color="blue darken-1" text @click="deleteItemConfirm"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

    <v-navigation-drawer
      v-model="showFormDrawer"
      absolute
      temporary
      right
      class="form-drawer"
    >
      <v-container fluid>
        <v-btn
          class="close elavation-0 mx-4 mx-md-3"
          icon
          @click="closeForm"
          small
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <form-link-render :src="editedItem.link"></form-link-render>
      </v-container>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
/* eslint-disable */
import dbForms from "./smartforms.controller";
export default {
  name: "SmartForms",
  route: {
    path: "/smart-forms",
    name: "Smart Forms",
  },
  components: {
    FormLinkRender: () => import("./components/FormLinkRender.vue"),
  },
  data() {
    return {
      renderTable: true,
      tagSearch: null,
      search: "",
      showFormDrawer: false,
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "Tag(s)", value: "tags" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      forms: [
        {
          name: "Self Service Request",
          link:
            "https://app.smartsheet.com/b/form/0eb1cfcb6eb24833bf30137b475e332b",
          tags: [],
        },
      ],
      tags: ["Bejing 2022", "Tokyo 2020", "Athlete"],
      formTitle: "Form Title",
      selected: {},
      editedIndex: -1,
      editedItem: {
        name: "",
        link: "",
        tags: [],
      },
      defaultItem: {
        name: "",
        link: "",
        tags: [],
      },
      dialog: false,
      dialogDelete: false,
    };
  },
  watch: {
    showFormDrawer(newVal) {
      // ENABLES THE USE OF ESC KEY TO CLOSE DRAWER
      //console.log(newVal);
      if (newVal) {
        // if open add event listener
        document.addEventListener("keydown", this.toggleDrawer);
      } else {
        // else remove event listener
        document.removeEventListener("keydown", this.toggleDrawer);
      }
    },
    "editedItem.tags": function() {
      this.checkTags();
      let ref = this.$refs.formTags;
      if (ref) {
        // closes v-combox dropdown menu
        ref.blur();
      }
    },
  },
  methods: {
    init() {
      this.forms = this.$app.data.smartForms;
    },
    openForm(item) {
      this.editedItem = item;
      this.showFormDrawer = true;
    },
    closeForm() {
      this.showFormDrawer = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    toggleDrawer(event) {
      if (event.key === "Escape") {
        //do something
        this.showFormDrawer = !this.showFormDrawer;
      }
    },
    editItem(item) {
      this.editedIndex = this.forms.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.forms.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      dbForms.delete(this.editedItem).then(() => {
        this.forms.splice(this.editedIndex, 1);
      });
      this.$app.alert("Form Deleted!");
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      console.log("this.editedIndex", this.editedIndex);
      const _this = this;
      if (this.editedIndex > -1) {
        // UPDATE EXISTING
        // let item = _this.editItem;
        // let itemIndex = _this.editedIndex;
        // let _editedItem = {
        //   ..._this.forms[itemIndex],
        //   ...item,
        // };
        // _this.forms.splice(itemIndex, 1, _editedItem);

        dbForms.update(this.editedItem).then(() => {
          this.init();
          this.$app.alert("Form Updated!");
        });
      } else {
        // NEW FORM
        this.forms.push(this.editedItem);
        dbForms.add(this.editedItem);
        this.$app.alert("New Form Sucessfully Saved!");
      }
      this.close();
    },
    checkTags() {
      // checks tags of editedItem and adds new ones to tags array
      function arr_diff(a1, a2) {
        var a = [],
          diff = [];
        for (var i = 0; i < a1.length; i++) {
          a[a1[i]] = true;
        }
        for (var i = 0; i < a2.length; i++) {
          if (a[a2[i]]) {
            delete a[a2[i]];
          } else {
            a[a2[i]] = true;
          }
        }
        for (var k in a) {
          diff.push(k);
        }
        return diff;
      }
      let tags = this.tags;
      let itemTags = this.editedItem.tags;
      let newTags = arr_diff(tags, itemTags);
      newTags.forEach((item) => tags.push(item));
    },
    reRender() {
      this.renderTable = false;
      this.$nextTick(() => {
        this.renderTable = true;
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss">
.form-drawer {
  width: 100% !important;
  .close {
    position: absolute;
    top: 4px;
    right: 5px;
    z-index: 10;
  }
  #form-iframe {
    overflow: hidden;
    overflow-x: hidden;
    overflow-y: hidden;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
  }
}

.form-row {
  cursor: pointer;
}
</style>
